import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { pipe, remote } from '@code-expert/prelude';
/**
 * Guard a render tree from rendering unless we have a value
 */
export const GuardRemote = ({ value, render, pending, initial = pending, }) => (_jsx(_Fragment, { children: pipe(value, remote.fold(initial, pending, render)) }));
//# sourceMappingURL=GuardRemote.js.map